import React from 'react';

import { FilterContext, FilterType } from '../contexts/Filter.context';

export const useFilters = (): FilterType => {
  return React.useContext(FilterContext);
};
